import { component, primitives, semantic, size, space, textStyle, theme } from './tokens';

export const figmaTokenMap = {
  'color-black-alpha-100': primitives.color.black['color-black-alpha-100'],
  'color-black-alpha-200': primitives.color.black['color-black-alpha-200'],
  'color-black-alpha-300': primitives.color.black['color-black-alpha-300'],
  'color-black-alpha-400': primitives.color.black['color-black-alpha-400'],
  'color-black-alpha-500': primitives.color.black['color-black-alpha-500'],
  'color-black-alpha-600': primitives.color.black['color-black-alpha-600'],
  'color-black-alpha-700': primitives.color.black['color-black-alpha-700'],
  'color-black-alpha-800': primitives.color.black['color-black-alpha-800'],
  'color-black-alpha-900': primitives.color.black['color-black-alpha-900'],
  'color-black-alpha-1000': primitives.color.black['color-black-alpha-1000'],
  'color-white-alpha-100': primitives.color.white['color-white-alpha-100'],
  'color-white-alpha-200': primitives.color.white['color-white-alpha-200'],
  'color-white-alpha-300': primitives.color.white['color-white-alpha-300'],
  'color-white-alpha-400': primitives.color.white['color-white-alpha-400'],
  'color-white-alpha-500': primitives.color.white['color-white-alpha-500'],
  'color-white-alpha-600': primitives.color.white['color-white-alpha-600'],
  'color-white-alpha-700': primitives.color.white['color-white-alpha-700'],
  'color-white-alpha-800': primitives.color.white['color-white-alpha-800'],
  'color-white-alpha-900': primitives.color.white['color-white-alpha-900'],
  'color-white-alpha-1000': primitives.color.white['color-white-alpha-1000'],
  'color-blue-100': primitives.color.blue['color-blue-100'],
  'color-blue-600': primitives.color.blue['color-blue-600'],
  'color-blue-700': primitives.color.blue['color-blue-700'],
  'color-green-100': primitives.color.green['color-green-100'],
  'color-green-600': primitives.color.green['color-green-600'],
  'color-green-700': primitives.color.green['color-green-700'],
  'color-yellow-100': primitives.color.yellow['color-yellow-100'],
  'color-yellow-600': primitives.color.yellow['color-yellow-600'],
  'color-yellow-700': primitives.color.yellow['color-yellow-700'],
  'color-red-100': primitives.color.red['color-red-100'],
  'color-red-600': primitives.color.red['color-red-600'],
  'color-red-700': primitives.color.red['color-red-700'],

  'weight-400': primitives.typography.weight['weight-400'],
  'weight-500': primitives.typography.weight['weight-500'],
  'line-height-100': primitives.typography['line-height']['line-height-100'],
  'line-height-200': primitives.typography['line-height']['line-height-200'],
  'track-neg-100': primitives.typography.track['track-neg-100'],
  'track-neg-050': primitives.typography.track['track-neg-050'],
  'track-0': primitives.typography.track['track-0'],
  'track-050': primitives.typography.track['track-050'],
  'scale-text-100': primitives.typography['scale-text']['scale-text-100'],
  'scale-text-200': primitives.typography['scale-text']['scale-text-200'],
  'scale-text-300': primitives.typography['scale-text']['scale-text-300'],
  'scale-text-400': primitives.typography['scale-text']['scale-text-400'],
  'scale-text-500': primitives.typography['scale-text']['scale-text-500'],
  'scale-text-600': primitives.typography['scale-text']['scale-text-600'],
  'scale-text-700': primitives.typography['scale-text']['scale-text-700'],
  'scale-text-800': primitives.typography['scale-text']['scale-text-800'],
  'scale-text-900': primitives.typography['scale-text']['scale-text-900'],
  'scale-text-1000': primitives.typography['scale-text']['scale-text-1000'],
  'scale-text-1100': primitives.typography['scale-text']['scale-text-1100'],

  'size-0': primitives.size['size-0'],
  'size-025': primitives.size['size-025'],
  'size-050': primitives.size['size-050'],
  'size-100': primitives.size['size-100'],
  'size-200': primitives.size['size-200'],
  'size-300': primitives.size['size-300'],
  'size-400': primitives.size['size-400'],
  'size-500': primitives.size['size-500'],
  'size-600': primitives.size['size-600'],
  'size-700': primitives.size['size-700'],
  'size-800': primitives.size['size-800'],
  'size-900': primitives.size['size-900'],
  'size-1000': primitives.size['size-1000'],
  'size-1100': primitives.size['size-1100'],
  'size-1200': primitives.size['size-1200'],
  'size-1400': primitives.size['size-1400'],
  'size-1600': primitives.size['size-1600'],
  'size-2000': primitives.size['size-2000'],
  'size-2400': primitives.size['size-2400'],
  'size-3000': primitives.size['size-3000'],
  'size-4000': primitives.size['size-4000'],
  'size-6000': primitives.size['size-6000'],
  'size-full': primitives.size['size-full'],
  'size-neg-025': primitives.size['size-neg-025'],
  'size-neg-050': primitives.size['size-neg-050'],
  'size-neg-100': primitives.size['size-neg-100'],
  'size-neg-200': primitives.size['size-neg-200'],
  'size-neg-400': primitives.size['size-neg-400'],
  'size-neg-800': primitives.size['size-neg-800'],
  'size-neg-1200': primitives.size['size-neg-1200'],

  'theme-color-brand-primary': theme.color['theme-color-brand-primary'],
  'theme-color-brand-bg': theme.color['theme-color-brand-bg'],
  'theme-font-brand-primary': theme.fonts['theme-font-brand-primary'],
  'theme-font-brand-secondary': theme.fonts['theme-font-brand-secondary'],

  'color-text-primary': semantic.text.primary,
  'color-text-secondary': semantic.text.secondary,
  'color-text-tertiary': semantic.text.tertiary,
  'color-text-inverse': semantic.text.inverse,
  'color-text-disabled': semantic.text.disabled,
  'color-text-brand': semantic.text.brand,
  'color-text-danger': semantic.text.danger,
  'color-text-positive': semantic.text.positive,
  'color-text-info': semantic.text.info,
  'color-text-warning': semantic.text.warning,

  'color-bg-primary': semantic.bg.primary,
  'color-bg-secondary': semantic.bg.secondary,
  'color-bg-canvas': semantic.bg.canvas,
  'color-bg-brand': semantic.bg.brand,
  'color-bg-surface-subtle': semantic.bg.surfaceSubtle,
  'color-bg-surface-default': semantic.bg.surfaceDefault,
  'color-bg-surface-strong': semantic.bg.surfaceStrong,
  'color-bg-surface-inverse-subtle': semantic.bg.surfaceInverseSubtle,
  'color-bg-surface-inverse-default': semantic.bg.surfaceInverseDefault,
  'color-bg-surface-inverse-strong': semantic.bg.surfaceInverseStrong,
  'color-bg-overlay-blur': semantic.bg.overlayBlur,
  'color-bg-overlay-image': semantic.bg.overlayImage,
  'color-bg-overlay-modal': semantic.bg.overlayModal,
  'color-bg-disabled': semantic.bg.disabled,
  'color-bg-info-subtle': semantic.bg.infoSubtle,
  'color-bg-info-strong': semantic.bg.infoStrong,
  'color-bg-positive-subtle': semantic.bg.positiveSubtle,
  'color-bg-positive-strong': semantic.bg.positiveStrong,
  'color-bg-danger-subtle': semantic.bg.dangerSubtle,
  'color-bg-danger-strong': semantic.bg.dangerStrong,
  'color-bg-warning-subtle': semantic.bg.warningSubtle,
  'color-bg-warning-strong': semantic.bg.warningStrong,
  'color-bg-urgency-strong': semantic.bg.urgencyStrong,

  'color-border-primary': semantic.border.primary,
  'color-border-secondary': semantic.border.secondary,
  'color-border-inverse': semantic.border.inverse,
  'color-border-selected': semantic.border.selected,
  'color-border-disabled': semantic.border.disabled,
  'color-border-positive': semantic.border.positive,
  'color-border-warning': semantic.border.warning,
  'color-border-info': semantic.border.info,
  'color-border-danger': semantic.border.danger,

  'color-icon-primary': semantic.icon.primary,
  'color-icon-secondary': semantic.icon.secondary,
  'color-icon-tertiary': semantic.icon.tertiary,
  'color-icon-inverse': semantic.icon.inverse,
  'color-icon-disabled': semantic.icon.disabled,
  'color-icon-positive': semantic.icon.positive,
  'color-icon-warning': semantic.icon.warning,
  'color-icon-info': semantic.icon.info,
  'color-icon-danger': semantic.icon.danger,

  'space-0': space['space-0'],
  'space-050': space['space-050'],
  'space-100': space['space-100'],
  'space-200': space['space-200'],
  'space-300': space['space-300'],
  'space-400': space['space-400'],
  'space-500': space['space-500'],
  'space-600': space['space-600'],
  'space-700': space['space-700'],
  'space-800': space['space-800'],
  'space-900': space['space-900'],
  'space-1000': space['space-1000'],
  'space-1100': space['space-1100'],
  'space-1200': space['space-1200'],
  'space-1400': space['space-1400'],
  'space-1600': space['space-1600'],
  'space-2000': space['space-2000'],
  'space-2400': space['space-2400'],
  'space-3000': space['space-3000'],
  'space-4000': space['space-4000'],
  'space-6000': space['space-6000'],
  'space-neg-400': space['space-neg-400'],

  'radius-xs': size.radius['radius-xs'],
  'radius-sm': size.radius['radius-sm'],
  'radius-md': size.radius['radius-md'],
  'radius-lg': size.radius['radius-lg'],
  'radius-xl': size.radius['radius-xl'],
  'radius-xxl': size.radius['radius-xxl'],
  'radius-full': size.radius['radius-full'],
  'blur-sm': size.blur['blur-sm'],
  'blur-md': size.blur['blur-md'],
  'blur-lg': size.blur['blur-lg'],
  'stroke-default': size.stroke['stroke-default'],
  'stroke-thick': size.stroke['stroke-thick'],
  'icon-sm': size.icon['icon-sm'],
  'icon-md': size.icon['icon-md'],
  'icon-lg': size.icon['icon-lg'],
  'icon-xl': size.icon['icon-xl'],
  'depth-none': size.depth['depth-none'],
  'depth-xs': size.depth['depth-xs'],
  'depth-sm': size.depth['depth-sm'],
  'depth-md': size.depth['depth-md'],
  'depth-lg': size.depth['depth-lg'],
  'depth-xl': size.depth['depth-xl'],
  'depth-neg-sm': size.depth['depth-neg-sm'],
  'depth-neg-md': size.depth['depth-neg-md'],
  'depth-neg-lg': size.depth['depth-neg-lg'],

  'body-size-xs': textStyle.body.xs.regular.fontSize,
  'body-size-sm': textStyle.body.sm.regular.fontSize,
  'body-size-md': textStyle.body.md.regular.fontSize,
  'body-size-lg': textStyle.body.lg.regular.fontSize,
  'title-size-sm': textStyle.title.sm.fontSize,
  'title-size-md': textStyle.title.md.fontSize,
  'title-size-lg': textStyle.title.lg.fontSize,
  'headline-size-sm': textStyle.headline['size-sm'].fontSize,
  'headline-size-md': textStyle.headline['size-md'].fontSize,
  'headline-size-lg': textStyle.headline['size-lg'].fontSize,
  'display-size-md': textStyle.display['size-md'].fontSize,
  'display-size-lg': textStyle.display['size-lg'].fontSize,

  'button-primary-enabled-bg': component.button.primary.enabled.bg,
  'button-primary-enabled-text': component.button.primary.enabled.text,
  'button-primary-enabled-icon': component.button.primary.enabled.icon,
  'button-primary-hover-bg': component.button.primary.hover.bg,
  'button-primary-hover-text': component.button.primary.hover.text,
  'button-primary-hover-icon': component.button.primary.hover.icon,
  'button-primary-focussed-bg': component.button.primary.focussed.bg,
  'button-primary-focussed-text': component.button.primary.focussed.text,
  'button-primary-focussed-icon': component.button.primary.focussed.icon,
  'button-primary-pressed-bg': component.button.primary.pressed.bg,
  'button-primary-pressed-text': component.button.primary.pressed.text,
  'button-primary-pressed-icon': component.button.primary.pressed.icon,
  'button-primary-disabled-bg': component.button.primary.disabled.bg,
  'button-primary-disabled-text': component.button.primary.disabled.text,
  'button-primary-disabled-icon': component.button.primary.disabled.icon,

  'button-secondary-enabled-bg': component.button.secondary.enabled.bg,
  'button-secondary-enabled-text': component.button.secondary.enabled.text,
  'button-secondary-enabled-icon': component.button.secondary.enabled.icon,
  'button-secondary-hover-bg': component.button.secondary.hover.bg,
  'button-secondary-hover-text': component.button.secondary.hover.text,
  'button-secondary-hover-icon': component.button.secondary.hover.icon,
  'button-secondary-focussed-bg': component.button.secondary.focussed.bg,
  'button-secondary-focussed-text': component.button.secondary.focussed.text,
  'button-secondary-focussed-icon': component.button.secondary.focussed.icon,
  'button-secondary-pressed-bg': component.button.secondary.pressed.bg,
  'button-secondary-pressed-text': component.button.secondary.pressed.text,
  'button-secondary-pressed-icon': component.button.secondary.pressed.icon,
  'button-secondary-disabled-bg': component.button.secondary.disabled.bg,
  'button-secondary-disabled-text': component.button.secondary.disabled.text,
  'button-secondary-disabled-icon': component.button.secondary.disabled.icon,

  'button-neutral-enabled-bg': component.button.neutral.enabled.bg,
  'button-neutral-enabled-text': component.button.neutral.enabled.text,
  'button-neutral-enabled-icon': component.button.neutral.enabled.icon,
  'button-neutral-hover-bg': component.button.neutral.hover.bg,
  'button-neutral-hover-text': component.button.neutral.hover.text,
  'button-neutral-hover-icon': component.button.neutral.hover.icon,
  'button-neutral-focussed-bg': component.button.neutral.focussed.bg,
  'button-neutral-focussed-text': component.button.neutral.focussed.text,
  'button-neutral-focussed-icon': component.button.neutral.focussed.icon,
  'button-neutral-pressed-bg': component.button.neutral.pressed.bg,
  'button-neutral-pressed-text': component.button.neutral.pressed.text,
  'button-neutral-pressed-icon': component.button.neutral.pressed.icon,
  'button-neutral-disabled-bg': component.button.neutral.disabled.bg,
  'button-neutral-disabled-text': component.button.neutral.disabled.text,
  'button-neutral-disabled-icon': component.button.neutral.disabled.icon,

  'button-destructive-enabled-bg': component.button.destructive.enabled.bg,
  'button-destructive-enabled-text': component.button.destructive.enabled.text,
  'button-destructive-enabled-icon': component.button.destructive.enabled.icon,
  'button-destructive-hover-bg': component.button.destructive.hover.bg,
  'button-destructive-hover-text': component.button.destructive.hover.text,
  'button-destructive-hover-icon': component.button.destructive.hover.icon,
  'button-destructive-focussed-bg': component.button.destructive.focussed.bg,
  'button-destructive-focussed-text': component.button.destructive.focussed.text,
  'button-destructive-focussed-icon': component.button.destructive.focussed.icon,
  'button-destructive-pressed-bg': component.button.destructive.pressed.bg,
  'button-destructive-pressed-text': component.button.destructive.pressed.text,
  'button-destructive-pressed-icon': component.button.destructive.pressed.icon,
  'button-destructive-disabled-bg': component.button.destructive.disabled.bg,
  'button-destructive-disabled-text': component.button.destructive.disabled.text,
  'button-destructive-disabled-icon': component.button.destructive.disabled.icon,

  'button-transparent-enabled-bg': component.button.transparent.enabled.bg,
  'button-transparent-enabled-text': component.button.transparent.enabled.text,
  'button-transparent-enabled-icon': component.button.transparent.enabled.icon,
  'button-transparent-hover-bg': component.button.transparent.hover.bg,
  'button-transparent-hover-text': component.button.transparent.hover.text,
  'button-transparent-hover-icon': component.button.transparent.hover.icon,
  'button-transparent-focussed-bg': component.button.transparent.focussed.bg,
  'button-transparent-focussed-text': component.button.transparent.focussed.text,
  'button-transparent-focussed-icon': component.button.transparent.focussed.icon,
  'button-transparent-pressed-bg': component.button.transparent.pressed.bg,
  'button-transparent-pressed-text': component.button.transparent.pressed.text,
  'button-transparent-pressed-icon': component.button.transparent.pressed.icon,
  'button-transparent-disabled-bg': component.button.transparent.disabled.bg,
  'button-transparent-disabled-text': component.button.transparent.disabled.text,
  'button-transparent-disabled-icon': component.button.transparent.disabled.icon,

  'button-blur-enabled-bg': component.button.blur.enabled.bg,
  'button-blur-enabled-text': component.button.blur.enabled.text,
  'button-blur-enabled-icon': component.button.blur.enabled.icon,
  'button-blur-hover-bg': component.button.blur.hover.bg,
  'button-blur-hover-text': component.button.blur.hover.text,
  'button-blur-hover-icon': component.button.blur.hover.icon,
  'button-blur-focussed-bg': component.button.blur.focussed.bg,
  'button-blur-focussed-text': component.button.blur.focussed.text,
  'button-blur-focussed-icon': component.button.blur.focussed.icon,
  'button-blur-pressed-bg': component.button.blur.pressed.bg,
  'button-blur-pressed-text': component.button.blur.pressed.text,
  'button-blur-pressed-icon': component.button.blur.pressed.icon,
  'button-blur-disabled-bg': component.button.blur.disabled.bg,
  'button-blur-disabled-text': component.button.blur.disabled.text,
  'button-blur-disabled-icon': component.button.blur.disabled.icon,
} as const;

export type FigmaTokenName = keyof typeof figmaTokenMap;
